import { LegacyColumn as Column } from "components/MaterialTable/MatDataGridTypes";
import { USER_ROLE_MAPPER } from "./user";
import { formatDateTime } from "utils/formatters";
import { GENERAL_CONSTANTS } from "./general";

export const USERS_BUSINESS_UNIT_CONSTANTS = {
    USER_INVITED: 'User invitation sent successfully',
    USER_REMOVED: 'User removed from business unit successfully',
    INVITE_USER: 'Invite User',
    SEND_INVITATION: 'Send Invitation',
    BACK: GENERAL_CONSTANTS.BACK,
    NAME: GENERAL_CONSTANTS.NAME,
    EMAIL: GENERAL_CONSTANTS.CONTACT_EMAIL,
    BUSINESS_UNIT: GENERAL_CONSTANTS.BUSINESS_UNIT,
    USER_ROLE: GENERAL_CONSTANTS.USER_ROLE,
    USER_NAME: 'User Name',
    ROLE: 'Role',
    LAST_SIGN_IN: 'Last Sign In',
    EDIT: GENERAL_CONSTANTS.EDIT,
    REMOVE: GENERAL_CONSTANTS.REMOVE,
    TYPE_NAME: 'Type name...',
    TYPE_EMAIL: 'Type e-mail...',
    SELECT_VENDOR: GENERAL_CONSTANTS.SELECT_VENDOR,
    SELECT_ROLE: GENERAL_CONSTANTS.SELECT_ROLE,
    VALIDATION_REQUIRED: GENERAL_CONSTANTS.VALIDATION_REQUIRED,
    VALIDATION_INVALID_EMAIL: GENERAL_CONSTANTS.VALIDATION_INVALID_EMAIL,
    UPDATE_INVITATION: 'Update Invitation',
    DELETE_USER_PROFILE: 'Are you sure you want to remove this user(s)?',
    ALREADY_INVITED: 'This user is already invited as {role} role in this {scope}.\nTo change their role or remove them, go to:\nMy organization/Business unit/users tab',
    USER_ALREADY_HAS_PERMISSIONS: 'User already has permissions for this level or higher.',
    USER_IS_BUSINESS_UNIT_MEMBER: 'User is already a member of this business unit.'
};


export const BUSINESS_UNIT_USERS_COLUMNS: Column<any>[] = [
    {
        title: 'User Name',
        field: 'name',
        sorting: true,
        cellStyle: { fontWeight: 500 }
    },
    {
        title: 'Role',
        field: 'role',
        sorting: true,
        render: (rowData: any) => {
            return USER_ROLE_MAPPER[rowData.role] || 'N/A';
        }
    },
    {
        title: 'E-mail',
        field: 'email',
        sorting: true,
    },
    {
        title: 'Last Sign In',
        field: 'lastLogin',
        sorting: true,
        render: (rowData: any) => {
            return rowData.lastLogin !== 'N/A' ? formatDateTime(rowData.lastLogin) : 'N/A';
        }
    },
    {
        title: '',
        field: 'actions',
        sorting: false,
        width: '150px'
    }
];


export const BUSINESS_UNIT_USERS_COLUMNS_ORG: Column<any>[] = [
    {
        title: 'Business Unit',
        field: 'businessUnitName',
        sorting: true,
        cellStyle: { fontWeight: 500 },
        width: '200px',
        render: (rowData: any) => {
            return rowData.businessUnitName ? rowData.businessUnitName : 'All';
        }
    },
    ...BUSINESS_UNIT_USERS_COLUMNS
];

export const ADMINS_COLUMNS: Column<any>[] = [
    {
        title: 'Vendor',
        field: 'vendorName',
        sorting: true,
        render: (rowData: any) => {
            return rowData.vendorName || GENERAL_CONSTANTS.ALL;
        }
    },
    {
        title: 'User Name',
        field: 'name',
        sorting: true,
        cellStyle: { fontWeight: 500 }
    },
    {
        title: 'Role',
        field: 'role',
        sorting: true,
        render: (rowData: any) => {
            return USER_ROLE_MAPPER[rowData.role] || 'N/A';
        }
    },
    {
        title: 'E-mail',
        field: 'email',
        sorting: true,
    },
    {
        title: 'Last Sign In',
        field: 'lastLogin',
        sorting: true,
        render: (rowData: any) => {
            return rowData.lastLogin !== 'N/A' ? formatDateTime(rowData.lastLogin) : 'N/A';
        }
    },
    {
        title: '',
        field: 'actions',
        sorting: false,
        width: '150px'
    }
];

export const TEXT_LABELS = {
    CONTACT_EMAIL: GENERAL_CONSTANTS.CONTACT_EMAIL,
    NAME: GENERAL_CONSTANTS.NAME,
    USER_ROLE: GENERAL_CONSTANTS.USER_ROLE,
    BUSINESS_UNIT: GENERAL_CONSTANTS.BUSINESS_UNIT,
    GIN_ID: GENERAL_CONSTANTS.GIN,
    VENDOR: GENERAL_CONSTANTS.VENDOR
}

export const USER_FIELDS = {
    NAME: 'name',
    EMAIL: 'email',
    USER_ROLE: 'userRole',
    BUSINESS_UNIT: 'businessUnit',
    VENDOR: 'vendor',
    GIN_ID: 'ginId'
};